import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { SGKC007AService, Sgkc007aRequest, Sgkc007aResponse } from 'sg-api';

/**
 * 単価表詳細取得API使用サービス
 * @export
 * @class UsedSgkc007aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc007aService {

    /**単価表詳細取得結果のSubject */
    private _tankatableDetailResult$: Subject<Sgkc007aResponse> = new Subject<Sgkc007aResponse>();

    /**
   * コンストラクタ
   * @param {SGKC007AService} sGKC007AService
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {FeaturesLibConfig} featuresLibConfig 
   * @memberof UsedSgkc007aService
   */
    constructor(
        private sGKC007AService: SGKC007AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
    ) { }

    /**
    * 単価表詳細取得結果のobservable提供
    * @readonly
    * @memberof UsedSgkc007aService
    */
    get tankatableDetailChanges() {
        return this._tankatableDetailResult$.asObservable();
    }

    /**
   * 単価表詳細取得API呼び出し
   * @param {Sgkc007aRequest} value 
   * @return {Observable<Sgkc007aResponse>} 
   * @memberof UsedSgkc007aService
   */
    getTankatableDetail(value: Sgkc007aRequest): Observable<Sgkc007aResponse> {
        // 年月日項目のフォーマット
        this.apiCommonService.convertElementInObject(value, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
        // 検索条件を保存
        return this.sGKC007AService.kC10RSGKC007APost(<Sgkc007aRequest>this.apiCommonService.setRequestCommon(value), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    this._tankatableDetailResult$.next(response.body);
                    return response.body;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC007A');
                    return throwError(err.message);
                })
            );
    }
}
